export const ALERTS = 'ALERTS';
export const FLASHES = 'FLASHES';
export const INIT_ALERTS = 'INIT_ALERTS';
export const INITIALIZE_STORE = 'INITIALIZE_STORE';
